import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';

export default function dimensionsCell(
  viewFit: (vehicleId: number) => void,
) {
  return class extends React.Component<GridCustomCellProps> {
    render() {
      if (!this.props.field) return null;
      return (
        <td {...this.props.tdProps}>
          {this.props.dataItem.VehicleID ? <a
            href="#"
            style={{ color: '#007bff' }}
            onClick={(e) => {
              viewFit(this.props.dataItem.VehicleID)
              e.preventDefault();
            }}
          >
            {this.props.dataItem.BoxLength} x {this.props.dataItem.BoxWidth} x {this.props.dataItem.BoxHeight}
          </a> : `${this.props.dataItem.BoxLength} x ${this.props.dataItem.BoxWidth} x ${this.props.dataItem.BoxHeight}`}
        </td>
      );
    }

    public shouldComponentUpdate(nextProps: GridCustomCellProps) {
      return nextProps.dataItem.Hash !== this.props.dataItem.Hash;
    }
  }
}
